import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as en } from '../i18n/en.json';
import { default as de } from '../i18n/de.json';
import { SOFTLINE_PERMISSION_ABC_ANALYSIS } from './abc-analysis.shared';
import { abcAnalysisRoutes } from './abc-analysis.routes';

export function provideABCAnalysisProviders() {
  return provideSoftAppsModule(
    {
      name: 'abc-analysis',
      title: '#ABC_ANALYSIS.APP_TITLE',
      icon: 'fa-regular fa-chart-pie',
      route: '/abc-analysis/',
      permission: SOFTLINE_PERMISSION_ABC_ANALYSIS,
    },
    withSoftAppsModuleTranslation({ de, en }),
    withSoftAppsModuleRoutes({
      app: abcAnalysisRoutes,
    })
  );
}
